import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpHeaders,
  HttpErrorResponse
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let token = localStorage.getItem('token');
    request = request.clone({
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token ? token : ''
      })
    });
    return next.handle(request).pipe(catchError((error: HttpErrorResponse) => {
      console.log(error);
      if (error.status === 401) {
        this.authService.logout();
      }
      return throwError(() => new Error(error.message));
    }))
  }
}
